import React from "react";
import CG_FooterButtons from "./CG_FooterButtons";

export default function CG_AdditionalTermsConditions({ setFormData, formData, setCurrentScreen, currentScreen, navigate, screen }) {
    const months = Array.from({ length: 12 }, (_, i) => i + 1);
    const days = Array.from({ length: 31 }, (_, i) => i + 1);
    const years = Array.from({ length: 25 }, (_, i) => 2000 + i);

    const handleNext = (e) => {
        e.preventDefault();
        if (!formData.price || !formData.contingencies1 || !formData.size1 || !formData.stories1) {
            alert("Please fill out all required fields.");
            return;
        }
        setCurrentScreen(3);
        console.log("Form submitted successfully:", formData);
        // Proceed with further actions, such as navigating or API calls.
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((pre) => ({ ...pre, [name]: value }));
    };
    return (
        <form onSubmit={handleNext} className="tw-h-full tw-flex tw-flex-col tw-justify-between">
            <div className="tw-flex tw-w-full tw-flex-col tw-items-center">
                <h2 className="tw-mt-5 tw-text-center tw-font-[700] tw-text-[30px] tw-text-[#001659]">Additional terms & Conditions</h2>
                <div className="tw-w-full xl:tw-w-[70%] tw-flex tw-flex-col tw-items-center tw-gap-2 tw-mt-5">
                    <div className="tw-w-full">
                        <p className="tw-font-[600]">Closing Date:</p>
                        <div className="tw-flex tw-gap-5 tw-justify-between tw-items-center">
                            <select className="tw-bg-[#f1f1f1] tw-w-full tw-rounded-md tw-px-2 tw-py-1" required>
                                <option>Select Month</option>
                                {months.map((month) => (
                                    <option key={month} value={month}>
                                        {month}
                                    </option>
                                ))}
                            </select>
                            <select className="tw-bg-[#f1f1f1] tw-w-full tw-rounded-md tw-px-2 tw-py-1" required>
                                <option>Select Date</option>
                                {days.map((day) => (
                                    <option key={day} value={day}>
                                        {day}
                                    </option>
                                ))}
                            </select>
                            <select className="tw-bg-[# f1f1f1] tw-w-full tw-rounded-md tw-px-2 tw-py-1" required>
                                <option>Select Year</option>
                                {years.map((year) => (
                                    <option key={year} value={year}>
                                        {year}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="tw-w-full">
                        <p className="tw-font-[600]">Inspection requirement:</p>
                        <input placeholder="Enter your address" className="tw-bg-[#f1f1f1] tw-w-full tw-rounded-md tw-px-2 tw-py-1" required />
                    </div>

                    <div className="tw-w-full">
                        <p className="tw-font-[600]">Option:</p>
                        <input placeholder="Enter your option" className="tw-bg-[#f1f1f1] tw-w-full tw-rounded-md tw-px-2 tw-py-1" required />
                    </div>
                    <div className="tw-w-full">
                        <p className="tw-font-[600]">Option:</p>
                        <input placeholder="Enter your option" className="tw-bg-[#f1f1f1] tw-w-full tw-rounded-md tw-px-2 tw-py-1" required />
                    </div>
                </div>
            </div>
            <CG_FooterButtons currentScreen={currentScreen} setCurrentScreen={setCurrentScreen} navigate={navigate} />
        </form>
    );
}
